module.exports = __webpack_public_path__ + "static/media/_MIC2483.image.4d906eca.png";